// @ts-nocheck



import React from 'react';



import { vehicleApi, monthlyWashingPlanApi } from './../../../../lib/api';
import AutocompleteSelect from './../../../../components/selects/AutocompleteSelect';
import { convertVehicleToString } from './../../../../lib/helpers';











const defaultOptionName = (vehicle) => convertVehicleToString(vehicle);

export default ({
  optionTitle = defaultOptionName,
  monthlyWashingPlanId,
  filter = {},
  disabledValues = [],
  ...selectProps
}) =>
<AutocompleteSelect
  placeholder="Выберите ТС"
  fetch={async (params) => {
    const plan = await monthlyWashingPlanApi.fetchAllWashingPlanVehicles({
      ...params,
      washingPlanId: monthlyWashingPlanId
    });
    return {
      ...plan,
      data: plan.data.map((item) => item.vehicle)
    };
  }}
  refetchParams={{ filter }}
  fetchSingle={vehicleApi.fetchVehicle}
  notFoundText="ТС не найдены"
  renderOption={(vehicle, Option) =>
  <Option
    key={vehicle.id}
    value={vehicle.id}
    vehicle={vehicle}
    disabled={disabledValues.includes(vehicle.id)}>

        {optionTitle(vehicle)}
      </Option>
  }
  {...selectProps} />;
